import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { CLIENT_CONFIG } from '../graphql/queries/clientConfig';
export const useClientConfig = ({ clientId }) => {
    const { data } = useQuery(CLIENT_CONFIG, {
        variables: { clientId },
    });
    const clientConfig = useMemo(() => data?.clientConfig, [data?.clientConfig]);
    return {
        clientConfig,
        defaultLocale: clientConfig?.locale,
        timezone: clientConfig?.timezone,
    };
};
